/* eslint-disable react/prop-types */
import { createPortal } from 'react-dom'
import styles from './styles.module.css'
import { Cross } from '../../assets/svgs/icons'

const MODAL_TYPES = {
  DEFAULT: 'default',
}

export const ModalComponent = ({
  isOpen,
  onClose,
  type,
  children,
  style = {},
  overlayStyle = {},
  className
}) => {

  const handleClose = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const Modal_Default = () => {
    if (!isOpen) return null
    const modal = (
      <div className={styles.modal_overlay} onClick={handleClose} style={overlayStyle}>

        <div className={`${styles.modal_content} ${className}`} style={style}>
          <div className={styles.close_button} onClick={onClose}>
            {onClose && <Cross color="#000" width={20} height={20} />}
          </div>
          {children}
        </div>
      </div>
    )

    if (typeof document !== 'undefined' && document.body) {
      return createPortal(modal, document.body)
    }

    return modal
  }

  if (!type || type === MODAL_TYPES.DEFAULT) return <Modal_Default />
}

export default ModalComponent
